export const EditAdPageTestIds = {
  form: {
    form: 'edit-ad-form',
    title: 'edit-ad-title',
    adNumber: 'edit-ad-number',
  },
};
